var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.hash === '#booking' || _vm.$route.hash === '')?_c('div',[_vm._v(" BookingDocumentation ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }